export default __webpack_public_path__ + "static/media/7-7t.3c0ab008.png";